module.exports = __webpack_public_path__ + "img/0bef58d.png";